import data from "./data";

export const DATA_NAMESPACE = "data";

export default data;
